const base64js = require('base64-js');
import Validator from 'validatorjs';
import { default as FEATURES } from '../../common/feature-enum';

/* @ngInject */
export default class AuditsCaptureCtrl {
    constructor(
        $scope,
        $rootScope,
        $timeout,
        AuditsCaptureService,
        NotificationService,
        LocalStorageService,
        NavigationService,
        BuildingsService
    ) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.AuditsCaptureService = AuditsCaptureService;
        this.NotificationService = NotificationService;
        this.LocalStorageService = LocalStorageService;
        this.NavigationService = NavigationService;
        this.BuildingsService = BuildingsService;
        this.init();
        this.activate();
    }

    init() {
        this.isBusy = true;
        this.howToGuideLink;
        this.attachment = {};
        this.selectedAttachment = {};
        this.formsErrors = {
            first: [],
            second: [],
            header: []
        };

        this.documentsErrors = {
            first: [],
            second: [],
            header: []
        };

        this.hasAuditsDetailBeenSaved = false;
        this.AssigneeList = [];
        this.retrievedAuditDetails = {};
        this.auditorInfo = {};
        this.auditsQueryLogs = [];
        this.AuditQueryLogsId = {};
        this.SelectedAuditQueryLog = {};
        this.SpecificAuditQueryMessages = [];
        this.messageDate = {};
        this.messageTime = {};
        this.SpecificAuditQueryMessage = [];
        this.hideTextBox = true;
        this.auditorContactDetails = {};
        this.auditsHeaderDetails = {};
        this.auditsHeaderId = {};
        this.uploadedFileAttachment = {};
        this.savedFinancialPeriodHeaderId = {};
        this.queryNum = {};
        this.queryNumberForQueryMessage = {};
        this.fileInputUrl = {};
        this.expansionAttachment = {};
        this.expansionAttachmentperQuery = {};
        this.ListOfAuditsUploadedDocs = [];
        this.ListOfAuditsUploadedLinks = [];
        this.ListOfAuditsPerQueryUploadedDocs = [];
        this.queryNumberForPerQueryDoc = {};
        this.selectedBuildingRef = {};
    }

    async activate() {
        this.howToGuideLink = `${PretorCDNAddress}${PretorCDNAddress.endsWith('/')
            ? ''
            : '/'}docs/Audits How-To-Guide.pdf`;

        this.selectedBuildingRef = this.LocalStorageService.retrieve("selectedBuildingRef");
        this.BuildingsService.setSelectedBuildingRef(this.selectedBuildingRef);
        this.$rootScope.$broadcast('selected-building-changed', this.selectedBuildingRef);
        this.$scope.$broadcast('selected-building-changed', this.selectedBuildingRef);

        try {
            const buildingProfiles = this.LocalStorageService.retrieve("userProfile").BuildingProfiles;
            const building = buildingProfiles.find(item => item["SchemeReference"] === this.selectedBuildingRef);
            var $element = angular.element('#selectedBuildingTitle');
            if (building) {
                $element.text(building.SchemeName)
            } else {
                $element.text('Welcome to your dashboard!');
            }
        } catch (error) {
            console.error(`audits-capture-ctrl: errror - ${error}`);
        }

        await this.getGeneratedAuditsTokenHistory();
    }

    async goBackToDashboard() {
        this.LocalStorageService.delete("auditsFinancialPeriodHeaderId");
        this.$rootScope.$broadcast('navigate-changed', FEATURES.AUDITORS_DASHBOARD);
    }

    async getGeneratedAuditsTokenHistory() {
        const correlationId = this.LocalStorageService.retrieve('auditsCorrelationId');

        this.selectedBuildingRef = this.LocalStorageService.retrieve("selectedBuildingRef");
        this.BuildingsService.setSelectedBuildingRef(this.selectedBuildingRef);
        this.$rootScope.$broadcast('selected-building-changed', this.selectedBuildingRef);
        this.$scope.$broadcast('selected-building-changed', this.selectedBuildingRef);

        if (correlationId) {
            var tokenHistory = await this.AuditsCaptureService.getAuditsTokenHistoryByCorrelationId(correlationId);
            var financialPeriodHeaderId = tokenHistory.FinancialPeriodHeaderId;
            var db_Ref = tokenHistory.DB_Ref;
            this.savedFinancialPeriodHeaderId = financialPeriodHeaderId;
            var auditsHeaderDetail = await this.AuditsCaptureService.getAuditsHeaderByFinancialPeriodHeaderId(financialPeriodHeaderId, db_Ref);
            this.auditsHeaderDetails = auditsHeaderDetail
            this.auditsHeaderId = auditsHeaderDetail.Id;

            this.$timeout(() => {
                try {
                    this.fileUpload();
                    this.populateAuditsDetail();
                    this.getAuditQueryLogs(this.auditsHeaderId);
                    this.getAllDocsforLink(financialPeriodHeaderId)
                } catch (error) {
                    console.error(`Audits-controller: Error - ${error}`);
                }
            }, 100);
        }

        this._switchIsBusy(false);
    }

    async getAllDocsforLink(financialPeriodHeaderId) {
        var result = await this.AuditsCaptureService.getUploadedDocumentsByFinancialPeriodHeaderId(financialPeriodHeaderId);
        //ListOfAuditsUploadedLinks
        var valueToRemove = "Link";
        for (var i = result.Data.length - 1; i >= 0; i--) {
            if (result.Data[i].FileType === valueToRemove) {
                this.ListOfAuditsUploadedLinks.push(result.Data.splice(i, 1)[0]);
            }
        }
    }

    async getAuditQueryLogs(auditsHeaderId) {
        var results = await this.AuditsCaptureService.getAuditQueryLogsById(auditsHeaderId);
        let outstandingDays = 'outstandingDays';
        results.Data.forEach(function (searchResult) {

            if (searchResult.Status == 0) {
                searchResult.Status = 1
            }

            switch (searchResult.Status) {
                case 0:
                    searchResult.Status = "In Progress"
                    break;
                case 1:
                    searchResult.Status = "Queried"
                    break;
                case 2:
                    searchResult.Status = "Closed"
                    break;
                case 3:
                    searchResult.Status = "Completed"
                    break;
            }

            var dateChange = searchResult.DateLoged.substring(0, 10);
            searchResult.DateLoged = dateChange;
            var unformattedDate = Date.now();

            // Create a new Date object using the timestamp
            let date = new Date(unformattedDate);
            let year = date.getFullYear();
            let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            let day = String(date.getDate()).padStart(2, '0');

            // Form the YYYY-MM-DD string
            let formattedDate = `${year}-${month}-${day}`;
            let date1 = new Date(dateChange);
            let date2 = new Date(formattedDate);
            let differenceInMilliseconds = date1 - date2;

            // Convert milliseconds to days (1 day = 24 hours = 86400000 milliseconds)
            let differenceInDays = differenceInMilliseconds / (24 * 60 * 60 * 1000);
            var newDifferenceInDays = Math.abs(differenceInDays);
            searchResult[outstandingDays] = newDifferenceInDays;
        });
        this.auditsQueryLogs = results.Data;

        this.$timeout(() => {
            try {
                this.populateAuditsQueryLogs();
            } catch (error) {
                console.error(`Audits-controller: Error - ${error}`);
            }
        }, 100);
    }

    populateAuditsQueryLogs() {
        this.hasAuditsDetailBeenSaved = false;
        if (!this.AuditsCaptureService.auditsQueryLogs) {
            this._switchIsBusy(false);
            return false;
        }
        this._switchIsBusy(false);
    }

    populateAuditsDetail() {
        this.hasAuditsDetailBeenSaved = false;
        if (!this.AuditsCaptureService.auditsHeaderDetails) {
            this._switchIsBusy(false);
            return false;
        }
        this._switchIsBusy(false);
    }

    _switchIsBusy(flag) {
        this.$timeout(() => {
            this.isBusy = flag;
        });
    }

    async showAddQueryModal() {
        var auditsDetails = await this.AuditsCaptureService.auditsHeaderDetails;
        this.retrievedAuditDetails = auditsDetails;
        var portfolioManger = auditsDetails.Manager;
        var bookkeeper = auditsDetails.Bookkeeper;
        var auditorHeaderId = auditsDetails.AuditorHeaderId;
        var auditorResults = await this.AuditsCaptureService.getAuditorByAuditorHeaderId(auditorHeaderId);
        this.auditorInfo = auditorResults;
        var auditor = auditorResults.Auditor;

        $("#auditQueryBookkeeperText").text(bookkeeper + " (Bookkeeper)");
        $("#auditQueryPortfolioManagerText").text(portfolioManger + " (Portfolio Manager)");
        $("#auditQueryAuditorText").text(auditor + " (Auditor)");
        $("#auditQueryBookkeeper").text(bookkeeper);
        $("#auditQueryPortfolioManager").text(portfolioManger);
        $("#auditQueryAuditor").text(auditor);

        this.populateAssigneeList();
        var addQueryDoc = document.getElementById('addqueryAttachment');

        addQueryDoc.addEventListener('change', function (event) {
            var file = $('input[type=file]#addqueryAttachment')[0].files[0];
            var addFrameElement = document.getElementById("add_iframeView");
            let reader = new FileReader();

            if (file.type == '.pdf' || file.type == 'application/pdf') {

                var legitFile = checkFile(file); // Looks like this has to be done only for pdfs, so use the if statement above to handle non pdf files 
                if (legitFile == true) {

                    if (file !== undefined) {
                        reader.readAsArrayBuffer(file);
                        reader.onload = function () {
                            AuditsCaptureCtrl.addQueryAttachment = {
                                FileType: file.type,
                                Description: file.name,
                                IsFinalDraftAudit: false,
                                Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                            }
                            addFrameElement.src = URL.createObjectURL(file);
                            $('#add_iframeDiv').prop('hidden', false);
                        };
                    }
                }
                else {
                    document.getElementById('addqueryAttachment').value = null;
                    this.addQueryAttachment = {
                        FileName: null,
                        Blob: null,
                    }
                }
            } else {
                if (file !== undefined) {
                    reader.readAsArrayBuffer(file);
                    reader.onload = function () {
                        AuditsCaptureCtrl.addQueryAttachment = {
                            FileType: file.type,
                            Description: file.name,
                            IsFinalDraftAudit: false,
                            Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                        }
                        addFrameElement.src = "about:blank";
                        addFrameElement.contentWindow.document.write("<p>File to be uploaded: " + file.name + "</p>")
                        $('#add_iframeDiv').prop('hidden', false);
                    };
                }
            }
        });

        var checkFile = (file) => {
            if (file.type !== 'application/pdf') {
                const errorMsg = 'Wrong file type, only PDFs are allowed.';

                console.error(
                    `${errorMsg} "${file.name}" is not in the correct format - only PDFs are allowed.`
                );

                document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format - only PDFs are allowed.`;
                $("#attachmentFailureModal").modal('show');
                return false;
            }
            else if (file.name.length > 50) {
                const errorMsg = 'Filename too long. Please shorten your filename to less than 50 characters.';

                console.error(
                    `Filename too long. Please shorten your filename to less than 50 characters.`
                );
                document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format.`;
                $("#attachmentFailureModal").modal('show');
                return false;
            }
            else if (file.size > 5242880) {
                const errorMsg = 'File size too large. Please reduce the size of your file to smaller than 5 mega bytes.';

                console.error(
                    `File size too large. Please reduce the size of your file to smaller than 5 mega bytes.`
                );
                document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format.`;
                $("#attachmentFailureModal").modal('show');
                return false;
            }
            else {
                return true;
            }
        }
    }

    showAssigneeList() {
        var selectedAction = $('input[name="auditQueryRadio"]:checked').val();
        if (selectedAction == 4) {
            $("#possibleAssigneeListDiv").show();
        }
        else {
            $("#possibleAssigneeListDiv").hide();
        }
    }

    showReAssigneeList() {
        var selectedAction = $('input[name="reAssignQueryRadio"]:checked').val();
        if (selectedAction == 4) {
            $("#possibleReAssigneeListDiv").show();
        }
        else {
            $("#possibleReAssigneeListDiv").hide();
        }
    }

    async populateAssigneeList() {
        this.AssigneeList = [];
        var results = await this.AuditsCaptureService.getListOfAssignees();
        this.AssigneeList = results;
        for (var x = 0; x < this.AssigneeList.length; x++) {
            let newOption = new Option(this.AssigneeList[x], this.AssigneeList[x]);
            const selectAssignee = document.getElementById('selectedPossibleAssignee');
            selectAssignee.add(newOption, undefined);
        }
    }

    async populateReAssigneeList() {
        this.AssigneeList = [];
        var results = await this.AuditsCaptureService.getListOfAssignees();
        this.AssigneeList = results;
        for (var x = 0; x < this.AssigneeList.length; x++) {
            let newOption = new Option(this.AssigneeList[x], this.AssigneeList[x]);
            const selectAssignee = document.getElementById('selectedPossibleReAssignee');
            selectAssignee.add(newOption, undefined);
        }
    }

    async addQuery() {
        var selectedAction = $('input[name="auditQueryRadio"]:checked').val();
        var auditQuerySubjectText = document.getElementById('auditQuerySubjectText').value;
        var auditQueryMessageText = document.getElementById('auditQueryMessageText').value;

        var assignee = "";
        if (selectedAction == 1) {
            assignee = this.retrievedAuditDetails.Manager;
        }
        if (selectedAction == 2) {
            assignee = this.retrievedAuditDetails.Bookkeeper;
        }
        if (selectedAction == 3) {
            assignee = this.auditorInfo.Auditor;
        }
        if (selectedAction == 4) {
            var selectedAssignee = $('#selectedPossibleAssignee').find(":selected").text();
            assignee = selectedAssignee;
        }
        var username = this.auditorInfo.Auditor;

        var addQuerySelectedDoc = AuditsCaptureCtrl.addQueryAttachment;

        await this.AuditsCaptureService.addAuditQuery(assignee, this.retrievedAuditDetails, auditQuerySubjectText, auditQueryMessageText, selectedAction, username, addQuerySelectedDoc);
        this.cancelAddQuery();
        this.getAuditQueryLogs(this.auditsHeaderId);
    }

    cancelAddQuery() {
        document.getElementById('auditQuerySubjectText').value = "";
        document.getElementById('auditQueryMessageText').value = "";
        document.getElementById('possibleAssigneeListDiv').style.display = "none";
        document.getElementById('queryAttachmentSection').hidden = true;

        document.getElementById('auditQueryPortfolioManager').checked = false;
        document.getElementById('auditQueryBookkeeper').checked = false;
        document.getElementById('auditQueryAuditor').checked = false;
        document.getElementById('auditQueryOther').checked = false;

        document.getElementById("add_iframeView").value = "";
        document.getElementById('queryAttachmentTrue').checked = false;
        document.getElementById('queryAttachmentFalse').checked = false;
        $('#add_iframeDiv').prop('hidden', true);
    }


    removeCurrentAddQueryAttachment() {
        var addQueryFrameElement = document.getElementById("add_iframeView");
        addQueryFrameElement.src = "";
        $('#add_iframeDiv').prop('hidden', true);
    }

    removeCurrentOngoingAttachment() {
        var ongoingFrameElement = document.getElementById("onging_iframeView");
        ongoingFrameElement.src = "";
        $('#onging_iframeDiv').prop('hidden', true);
        $('#buttonSection').prop('hidden', true);
    }

    showEditQueryModal(AuditQueryLogsId, WhoLogged, Status) {
        this.AuditQueryLogsId = AuditQueryLogsId;
        var auditorDetails = this.AuditsCaptureService.auditorHeaderDetails

        if (WhoLogged != auditorDetails.Auditor) {
            $('#CloseQueryBtn').prop('disabled', true);
        } else {
            $('#CloseQueryBtn').prop('disabled', false);
        }

        if (Status == "Closed") {
            $('#ReAssignBtn').prop('disabled', true);
        } else {
            $('#ReAssignBtn').prop('disabled', false);
        }
    }

    async viewMessage(AuditQueryLogs) {
        var AuditQueryLogsId = AuditQueryLogs.Id;
        this.SelectedAuditQueryLog = AuditQueryLogs;
        this.AuditQueryLogsId = AuditQueryLogsId;
        var queryNumber = AuditQueryLogs.QueryNumber;
        this.queryNumberForQueryMessage = queryNumber;

        var financialPeriodHeaderId = this.savedFinancialPeriodHeaderId;
        var result = await this.AuditsCaptureService.getUploadedDocumentsByFinancialPeriodHeaderId(financialPeriodHeaderId);

        const attachmentPerQuery = result.Data.filter(MatchedQueries => MatchedQueries.QueryNumber === queryNumber);
        this.hideTextBox = false;

        var queryMessages = await this.AuditsCaptureService.getAuditQueryMessage(AuditQueryLogs.Id);
        console.log(queryMessages);
        queryMessages.Data.forEach(function (searchResult) {
            const dateTime = searchResult.DateSent;
            const dateTimeParts = dateTime.split('T');
            const datePart = dateTimeParts[0]; // Extract the date part
            const timePart = dateTimeParts[1].split('.')[0]; // Extract the time part without milliseconds
            searchResult.theDate = datePart;
            searchResult.theTime = timePart;
        });

        attachmentPerQuery.forEach(function (searchResult) {
            const dateTime = searchResult.WhenUploaded;
            const dateTimeParts = dateTime.split('T');
            const datePart = dateTimeParts[0]; // Extract the date part
            const timePart = dateTimeParts[1].split('.')[0]; // Extract the time part without milliseconds
            searchResult.QueryDate = datePart;
            searchResult.QueryTime = timePart;
        });

        if (attachmentPerQuery != 0) {
            const lastAttachment = attachmentPerQuery.length === 1 ? attachmentPerQuery[0] : attachmentPerQuery[attachmentPerQuery.length - 1];

            queryMessages.Data.forEach(message => {
                if (message.WhoSent === lastAttachment.WhoUploaded) {
                    message.OriginalFileName = lastAttachment.OriginalFileName;
                    message.QueryDate = lastAttachment.QueryDate;
                    message.QueryTime = lastAttachment.QueryTime;
                } else {
                    for (let i = attachmentPerQuery.length - 1; i >= 0; i--) {
                        const currentAttachment = attachmentPerQuery[i];
                        if (currentAttachment.WhoUploaded === message.WhoSent) {
                            message.OriginalFileName = currentAttachment.OriginalFileName;
                            message.QueryDate = currentAttachment.QueryDate;
                            message.QueryTime = currentAttachment.QueryTime;
                            break;
                        }
                    }
                }
            });

            this.SpecificAuditQueryMessages = queryMessages.Data;

        } else {
            queryMessages.Data.forEach(message => {

                message.OriginalFileName = null;
                message.WhenUploaded = null;
                message.QueryDate = null;
                message.QueryTime = null;
            });

            this.SpecificAuditQueryMessages = queryMessages.Data;
        }
    }

    async sendMessageLine() {
        var auditor = this.auditorInfo.Auditor;
        var auditsDetails = await this.AuditsCaptureService.auditsHeaderDetails;
        this.retrievedAuditDetails = auditsDetails;

        var auditorHeaderId = auditsDetails.AuditorHeaderId;
        var auditorResults = await this.AuditsCaptureService.getAuditorByAuditorHeaderId(auditorHeaderId);
        this.auditorInfo = auditorResults;
        var auditor = auditorResults.Auditor;

        await this.AuditsCaptureService.sendAuditQueryMessage(this.AuditQueryLogsId, this.SpecificAuditQueryMessage, auditor);
        this.SpecificAuditQueryMessage = "";
        this.viewMessage(this.SelectedAuditQueryLog);
    }

    async closeAuditQuery() {
        //Attempt to keep closed queries closed
        $('#ReAssignBtn').prop('disabled', true);
        var queryLogsId = this.AuditQueryLogsId;
        var queryStatus = 2;
        await this.AuditsCaptureService.closeTheAuditQuery(queryLogsId, queryStatus);
        location.reload();
    }

    async showReAssignSelectionDiv() {
        $("#reAssignSelectionDiv").show();
        $("#confirmReAssignQueryBTNDiv").show();
        var auditsDetails = await this.AuditsCaptureService.auditsHeaderDetails;
        this.retrievedAuditDetails = auditsDetails;
        var portfolioManger = auditsDetails.Manager;
        var bookkeeper = auditsDetails.Bookkeeper;
        var auditorHeaderId = auditsDetails.AuditorHeaderId;
        var auditorResults = await this.AuditsCaptureService.getAuditorByAuditorHeaderId(auditorHeaderId);
        this.auditorInfo = auditorResults;
        var auditor = auditorResults.Auditor;

        $("#reAssignQueryBookkeeperText").text(bookkeeper + " (Bookkeeper)");
        $("#reAssignQueryPortfolioManagerText").text(portfolioManger + " (Portfolio Manager)");
        $("#reAssignQueryAuditorText").text(auditor + " (Auditor)");
        $("#reAssignQueryBookkeeper").text(bookkeeper);
        $("#reAssignQueryPortfolioManager").text(portfolioManger);
        $("#reAssignQueryAuditor").text(auditor);

        this.populateReAssigneeList();
    }

    async confirmReAssignQuery() {
        var selectedAction = $('input[name="reAssignQueryRadio"]:checked').val();
        var auditsDetails = this.retrievedAuditDetails;
        var queryLogsId = this.AuditQueryLogsId;
        var auditorDetails = this.auditorInfo;

        var reAssignee = "";
        if (selectedAction == 1) {
            reAssignee = auditsDetails.Manager;
        }
        if (selectedAction == 2) {
            reAssignee = auditsDetails.Bookkeeper;
        }
        if (selectedAction == 3) {

            var auditor = auditorDetails.Auditor;
            reAssignee = auditor;
        }
        if (selectedAction == 4) {
            var selectedAssignee = $('#selectedPossibleReAssignee').find(":selected").text();
            reAssignee = selectedAssignee;
        }

        await this.AuditsCaptureService.reAssignAuditQueryById(queryLogsId, reAssignee, selectedAction);
        location.reload();
    }

    removeExternalSupportingDocAttachment() {
        var frameElement = document.getElementById("iframeView");
        frameElement.src = "";
        $('#iframeDiv').prop('hidden', true);
    }

    fileUpload() {       
        $(document).ready(function () {
            var stuff = document.getElementById('externalSupportingDoc');
            
            if (stuff != null) {
                stuff.addEventListener('change', function (event) {
                    $('#uploadDocBtn').prop('disabled', false);
                    var file2 = $('input[type=file]#externalSupportingDoc')[0].files[0];
                    var frameElement = document.getElementById("iframeView");

                    let reader = new FileReader();
                    var legitFile = check_file_pdf(file2);
                    if (legitFile == true) {

                        if (file2 !== undefined) {
                            reader.readAsArrayBuffer(file2);
                            reader.onload = function () {
                                AuditsCaptureCtrl.externalSupportDoc = {
                                    FileType: file2.type,
                                    FileName: file2.name,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                                frameElement.src = URL.createObjectURL(file2);
                                $('#iframeDiv').prop('hidden', false);
                            };
                        }
                    }
                    else {
                        document.getElementById('externalSupportingDoc').value = null;
                        this.externalSupportDoc = {
                            FileName: null,
                            Blob: null,
                        }
                    }
                });
            }
            else {
            }

            var check_file_pdf = (file) => {
                if (file.type !== 'application/pdf') {
                    const errorMsg = 'Wrong file type, only PDFs are allowed.';
                    console.error(
                        `${errorMsg} "${file.name}" is not in the correct format - only PDFs are allowed.`
                    );

                    document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format - only PDFs are allowed.`;
                    $("#attachmentFailureModal").modal('show');
                    return false;
                }
                else if (file.name.length > 50) {
                    const errorMsg = 'Filename too long. Please shorten your filename to less than 50 characters.';
                    console.error(
                        `Filename too long. Please shorten your filename to less than 50 characters.`
                    );
                    document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format.`;
                    $("#attachmentFailureModal").modal('show');
                    return false;
                }
                else if (file.size > 5242880) {
                    const errorMsg = 'File size too large. Please reduce the size of your file to smaller than 5 mega bytes.';
                    console.error(
                        `File size too large. Please reduce the size of your file to smaller than 5 mega bytes.`
                    );
                    document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format.`;
                    $("#attachmentFailureModal").modal('show');
                    return false;
                }
                else {
                    return true;
                }
            }
        });
    }

    async saveFile() {
        var auditorInfomat = this.AuditsCaptureService.auditorHeaderDetails;
        var documentSelectedAction = $('input[name="DocumentRadio"]:checked').val();
        var fileInputInfo = AuditsCaptureCtrl.externalSupportDoc;
        var documentType = 0;

        if (documentSelectedAction == "isFirstDraftAuditRadio") {
            documentType = 1;

        } else if (documentSelectedAction == "isFinalDraftAuditRadio") {
            documentType = 2;

        } else if (documentSelectedAction == "isFinalAuditorSignedAuditRadio") {
            documentType = 4;

        } else {
            documentType = null;
        }

        let filePayload = {
            Description: fileInputInfo.FileName,
            FileType: fileInputInfo.FileType,
            SchemeReference: this.auditsHeaderDetails.DB_Ref,
            FinancialPeriodHeaderId: this.savedFinancialPeriodHeaderId,
            Blob: fileInputInfo.Blob,
            Username: auditorInfomat.Auditor,
            DocumentType: documentType,
        };

        this._switchIsBusyUploadingDocumentLoading(true);

        await this.AuditsCaptureService.saveUploadedFile(
            filePayload
        )
            .then(
                () => {
                    this._switchIsBusyUploadingDocumentLoading(false);
                    if (this.AuditsCaptureService.auditsFile != null) {
                        $("#uploadingSuccessModal").modal('show');
                    } else {
                        $("#uploadingFailureModal").modal('show');
                    }
                }, (err) => { }
            )
            .finally(() => {
                this._switchIsBusyUploadingDocumentLoading(false);

            });
    }

    uploadQueryAttachmentTrue() {
        $("[name='uploadQueryAttachmentRadio']").change(function () {
            if ($('#queryAttachmentTrue').is(':checked')) {
                $('#queryAttachmentSection').prop('hidden', false);
            }
        });
    }

    uploadQueryAttachmentFalse() {
        $("[name='uploadQueryAttachmentRadio']").change(function () {
            if ($('#queryAttachmentFalse').is(':checked')) {
                $('#queryAttachmentSection').prop('hidden', true);
            }
        });
    }

    async viewUploadedDocuments() {
        var financialPeriodHeaderId = this.savedFinancialPeriodHeaderId;
        var result = await this.AuditsCaptureService.getUploadedDocumentsByFinancialPeriodHeaderId(financialPeriodHeaderId);

        result.Data.forEach(function (searchResult) {

            const dateTime = searchResult.WhenUploaded;
            const dateTimeParts = dateTime.split('T');
            const datePart = dateTimeParts[0]; // Extract the date part
            const timePart = dateTimeParts[1].split('.')[0]; // Extract the time part without milliseconds
            searchResult.WhenUploaded = datePart + ' ' + timePart;

            if (searchResult.DocumentType == 1) {
                searchResult.QueryNumber = "1st Draft"
            }
            else if (searchResult.DocumentType == 2) {
                searchResult.QueryNumber = "Final Draft"
            }
            else if (searchResult.DocumentType == 3) {
                searchResult.QueryNumber = "Client Signed AFS"
            }
            else if (searchResult.DocumentType == 4) {
                searchResult.QueryNumber = "Auditor Signed AFS"
            }
        });

        //ListOfAuditsUploadedLinks
        var valueToRemove = "Link";
        for (var i = result.Data.length - 1; i >= 0; i--) {
            if (result.Data[i].FileType === valueToRemove) {
                this.ListOfAuditsUploadedLinks.push(result.Data.splice(i, 1)[0]);
            }
        }
        this.ListOfAuditsUploadedDocs = result.Data;
        $("#uploadedDocsHistory").modal('show');
    }

    displayFinancialPackLink() {
        console.log(this.ListOfAuditsUploadedLinks[0].OriginalFileName);
        var link = this.ListOfAuditsUploadedLinks[0].OriginalFileName;
        window.open(link);
    }

    async viewUploadedDocumentsPerQuery(queryLog) {
        var financialPeriodHeaderId = this.savedFinancialPeriodHeaderId;
        var result = await this.AuditsCaptureService.getUploadedDocumentsByFinancialPeriodHeaderId(financialPeriodHeaderId);
        result.Data.forEach(function (searchResult) {
            const dateTime = searchResult.WhenUploaded;
            const dateTimeParts = dateTime.split('T');
            const datePart = dateTimeParts[0]; // Extract the date part
            const timePart = dateTimeParts[1].split('.')[0]; // Extract the time part without milliseconds
            searchResult.WhenUploaded = datePart + ' ' + timePart;
        });

        var queryNumber = queryLog.QueryNumber;
        this.queryNumberForPerQueryDoc = queryNumber;
        const attachmentPerQuery = result.Data.filter(MatchedQueries => MatchedQueries.QueryNumber === queryNumber);
        this.ListOfAuditsPerQueryUploadedDocs = attachmentPerQuery;
        $("#attachmentPerQueryModal").modal('show');
    }



    uploadOngoingQueryDoc(queryNumber, status) {
        var ongoingQueryDoc = document.getElementById('ongoingQueryAttachment');

        if (status == "Closed") {
            $("#closedQueryModal").modal('show');
        } else {
            $("#uploadOngoingQueryDoc").modal('show');
            this.queryNum = queryNumber;

            ongoingQueryDoc.addEventListener('change', function (event) {
                var file = $('input[type=file]#ongoingQueryAttachment')[0].files[0];
                var ongoingFrameElement = document.getElementById("onging_iframeView");
                let reader = new FileReader();
                if (file.type == '.pdf' || file.type == 'application/pdf') {
                    var legitFile = checkFile(file);
                    if (legitFile == true) {
                        if (file !== undefined) {
                            reader.readAsArrayBuffer(file);
                            reader.onload = function () {
                                AuditsCaptureCtrl.ongoingQueryAttachment = {
                                    FileType: file.type,
                                    Description: file.name,
                                    QueryNumber: this.queryNum,
                                    Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                                }
                                ongoingFrameElement.src = URL.createObjectURL(file);
                                $('#onging_iframeDiv').prop('hidden', false);
                                $('#buttonSection').prop('hidden', false);
                            };
                        }
                    }
                    else {
                        document.getElementById('ongoingQueryAttachment').value = null;
                        this.ongoingQueryAttachment = {
                            FileName: null,
                            Blob: null,
                        }
                    }
                } else {
                    if (file !== undefined) {
                        reader.readAsArrayBuffer(file);
                        reader.onload = function () {
                            AuditsCaptureCtrl.ongoingQueryAttachment = {
                                FileType: file.type,
                                Description: file.name,
                                QueryNumber: this.queryNum,
                                Blob: base64js.fromByteArray(new Uint8Array(reader.result))
                            }
                            ongoingFrameElement.src = "about:blank";
                            ongoingFrameElement.contentWindow.document.write("<p>File to be uploaded: " + file.name + "</p>")
                            $('#onging_iframeDiv').prop('hidden', false);
                            $('#buttonSection').prop('hidden', false);
                        };
                    }
                }
            });
        }

        var checkFile = (file) => {
            if (file.type !== 'application/pdf') {
                const errorMsg = 'Wrong file type, only PDFs are allowed.';
                console.error(
                    `${errorMsg} "${file.name}" is not in the correct format - only PDFs are allowed.`
                );

                document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format - only PDFs are allowed.`;
                $("#attachmentFailureModal").modal('show');
                return false;
            }
            else if (file.name.length > 50) {
                const errorMsg = 'Filename too long. Please shorten your filename to less than 50 characters.';
                console.error(
                    `Filename too long. Please shorten your filename to less than 50 characters.`
                );
                document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format.`;
                $("#attachmentFailureModal").modal('show');
                return false;
            }
            else if (file.size > 5242880) {
                const errorMsg = 'File size too large. Please reduce the size of your file to smaller than 5 mega bytes.';
                console.error(
                    `File size too large. Please reduce the size of your file to smaller than 5 mega bytes.`
                );
                document.getElementsByClassName("errorMessage")[0].innerText = `${errorMsg} "${file.name}" is not in the correct format.`;
                $("#attachmentFailureModal").modal('show');
                return false;
            }
            else {
                return true;
            }
        }
    }

    async saveUploadedOngoingDoc(queryNum) {
        var auditorInfomat = this.AuditsCaptureService.auditorHeaderDetails;
        var QueryNumber = queryNum;
        var fileInputInfo = AuditsCaptureCtrl.ongoingQueryAttachment;

        let filePayload = {
                Description: fileInputInfo.Description,
                FileType: fileInputInfo.FileType,
                SchemeReference: this.auditsHeaderDetails.DB_Ref,
                FinancialPeriodHeaderId: this.savedFinancialPeriodHeaderId,
                Blob: fileInputInfo.Blob,
                Username: auditorInfomat.Auditor,
                QueryNumber: QueryNumber,
                IsFinalDraftAudit: false
        };
        await this.AuditsCaptureService.saveUploadedFile(filePayload);
        this.removeCurrentOngoingAttachment();
        $("#uploadOngoingQueryDoc").modal('hide');
        $("#uploadingSuccessModal").modal('show');
    }

    previewUploadedDocument(blob, fileType, OriginalFileName) {
        console.log(fileType);
        if (fileType == ".pdf") {
            var binaryData = atob(blob);
            var arrayBuffer = new ArrayBuffer(binaryData.length);
            var uint8Array = new Uint8Array(arrayBuffer);
            for (var i = 0; i < binaryData.length; i++) {
                uint8Array[i] = binaryData.charCodeAt(i);
            }
            var theBlob = new Blob([arrayBuffer], { type: 'application/pdf' });
            var FrameElement = document.getElementById('viewUploadedDocFrame');
            FrameElement.src = URL.createObjectURL(theBlob);
            this.expansionAttachment = URL.createObjectURL(theBlob);
            $('#viewUploadedDocView').prop('hidden', false);
        }
        else if (fileType == ".zip")
        {
            var theBlob = new Blob([blob], { type: 'application/zip' });

            // Create a blob URL for the Blob
            var blobUrl = URL.createObjectURL(theBlob);

            // Create a hidden link element
            var link = document.createElement('a');
            link.href = blobUrl;
            link.download = OriginalFileName;

            // Append the link to the document body
            document.body.appendChild(link);

            // Trigger a click on the link to start the download
            link.click();

            // Remove the link and revoke the blob URL after the download starts
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        }
        else if (fileType == ".doc")
        {
            var theBlob = new Blob([blob], { type: 'application/msword' });
            var blobUrl = URL.createObjectURL(theBlob);

            // Create a hidden link element
            var link = document.createElement('a');
            link.href = blobUrl;
            link.download = OriginalFileName;

            document.body.appendChild(link);
            link.click();
            // Remove the link and revoke the blob URL after the download starts
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);

        } else if (fileType == ".xls" || fileType == ".xlsx") {
            var theBlob = new Blob([blob], { type: 'text/xls' });
            var blobUrl = URL.createObjectURL(theBlob);
            var link = document.createElement('a');
            link.href = blobUrl;
            link.download = OriginalFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        }
    }

    previewUploadedDocumentPerQuery(blob, fileType, OriginalFileName) {
        console.log(fileType);

        if (fileType == ".pdf") {
            var binaryData = atob(blob);
            var arrayBuffer = new ArrayBuffer(binaryData.length);
            var uint8Array = new Uint8Array(arrayBuffer);
            for (var i = 0; i < binaryData.length; i++) {
                uint8Array[i] = binaryData.charCodeAt(i);
            }
            var theBlob = new Blob([arrayBuffer], { type: 'application/pdf' });
            var FrameElement = document.getElementById('viewUploadedDocFramePerQuery');
            FrameElement.src = URL.createObjectURL(theBlob);
            this.expansionAttachmentperQuery = URL.createObjectURL(theBlob);
            $('#viewUploadedDocViewPerQuery').prop('hidden', false);
        }
        else if (fileType == ".zip") {
            var theBlob = new Blob([blob], { type: 'application/zip' });
            var blobUrl = URL.createObjectURL(theBlob);
            var link = document.createElement('a');
            link.href = blobUrl;
            link.download = OriginalFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        }
        else if (fileType == ".doc") {
            var theBlob = new Blob([blob], { type: 'application/msword' });
            var blobUrl = URL.createObjectURL(theBlob);
            var link = document.createElement('a');
            link.href = blobUrl;
            link.download = OriginalFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);

        } else if (fileType == ".xls" || fileType == ".xlsx") {
            var theBlob = new Blob([blob], { type: 'application/vnd.ms-excel' });
            var blobUrl = URL.createObjectURL(theBlob);
            var win = window.open(blobUrl, '_blank');
            // Create a hidden link element
            var link = document.createElement('a');
            link.href = blobUrl;
            link.download = OriginalFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        }
    }

    async getExcelDocByCorrelationId(corrId) {
        try {
            await this.AuditsCaptureService.getExcelDocByCorrelationId(corrId);
        } catch (error) {
        } finally {
        }
    }

    showExpandModal() {
        var FrameElement = document.getElementById('externalExpansionFrame');
        FrameElement.src = this.expansionAttachment;
        $("#expandCert").modal('show');
        $('#loadAttachment').prop('hidden', false);
    }

    showExpandModalPerQuery() {
        var FrameElement = document.getElementById('externalExpansionFrame');
        FrameElement.src = this.expansionAttachmentperQuery;
        $("#expandCert").modal('show');
        $('#loadAttachment').prop('hidden', false);
    }

    _switchIsBusyUploadingDocumentLoading(flag) {
        this.$timeout(() => {
            this.isLoading = flag;
        });
    }

    refresh() {
        window.location.reload();
    }
}
